<template>
  <div class="sticky top-0 z-50 bg-dark-gray">
    <Nav />
    <div>
      <div class="api__container flex flex-wrap">
        <div class="w-full items-center flex justify-between">
          <div class="h-full">
            <div class="bg-block-purple text-primary mb-3">
              <div class="flex">
                <div class="w-1/3 bg-green-neon text-green-neon">.</div>
                <div class="w-2/3 bg-light-purple text-light-purple">.</div>
              </div>
              <div class="px-6 py-6">
                <div class="w-full mb-3">
                  <img src="@/assets/img/Icons/api.png" alt="" />
                </div>
                <div class="flex items-center">
                  <div class="flex flex-col  mr-4">
                    <span class="font-neue">Órdenes</span>
                    <span
                      >Documentación de API para <br />
                      hacer órdenes de envíos</span
                    >
                  </div>
                  <div>
                    <a
                      href="/developers/api-orders"
                      class="uppercase bg-green-neon no-underline font-neue text-dark-purple py-3 px-12"
                    >
                      Ver Manual
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-block-purple text-primary">
              <div class="flex">
                <div class="w-1/3 bg-green-neon text-green-neon">.</div>
                <div class="w-2/3 bg-light-purple text-light-purple">.</div>
              </div>
              <div class="px-6 py-6">
                <div class="w-full mb-3">
                  <span class="font-neue text-4xl text-green-neon"
                    >MERCADO FLEX</span
                  >
                </div>
                <div class="flex items-center">
                  <div class="flex flex-col  mr-4">
                    <span class="font-neue">Órdenes</span>
                    <span
                      >Documentación de Mercado Flex <br />
                      para hacer órdenes de envíos</span
                    >
                  </div>
                  <div>
                    <a
                      href="/developers/mercado-flex"
                      class="uppercase bg-green-neon no-underline font-neue text-dark-purple py-3 px-12"
                    >
                      Ver Manual
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img src="@/assets/img/Icons/api_n.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="flujo-container w-full bg-white mt-3 flex flex-col items-center justify-center"
    >
      <div class="mb-4">
        <span class="text-dark-purple font-neue uppercase"
          >Flujo de Integración</span
        >
      </div>
      <div class="w-full flex justify-center">
        <img src="@/assets/img/Icons/flujograma.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.api__container {
  max-width: 1360px;
  margin: 20px auto 0px auto;

  @media only screen and (max-width: 1361px) {
    padding: 0 4%;
  }
}

.flujo-container {
  height: 53vh;
  z-index: -2;
  @media only screen and (min-width: 1500px) {
    height: 64vh;
  }
}

.flujo {
  border: 1px solid #212d3d;
  border-radius: 30px;
  background-color: #212d3d;
  padding: 2%;
  width: 80%;
  max-width: 1168px;
}

.bg__cards {
  background-color: #212d3d;
}
</style>
